import { FeedbackBanner } from "@/core/components/feedback-banner";
import { Button } from "@/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface DiscardAllEditsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
}

// Confirmation for discarding every manual edit on the run. Presentational — the
// sidebar owns the mutation and open state and passes them in.
export const DiscardAllEditsDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: DiscardAllEditsDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent description="Confirm discarding every manual edit on this run">
      <DialogHeader>
        <DialogTitle>Discard all edits?</DialogTitle>
      </DialogHeader>
      <Stack className="p-6 pt-0" gap="lg" fullWidth>
        <Typography variant="bodyW1" textColor="secondary">
          This reverts every edited cell to the value the payroll script
          produced and removes every row you added manually.
        </Typography>
        <FeedbackBanner variant="warning">
          <Typography variant="bodyW3">
            This can&apos;t be undone. Your manual edits and added rows for this
            run will be permanently discarded.
          </Typography>
        </FeedbackBanner>
      </Stack>
      <DialogFooter>
        <Button
          variant="secondary"
          disabled={isPending}
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          variant="destructive"
          loading={isPending}
          disabled={isPending}
          onClick={onConfirm}
        >
          Discard all edits
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
